// @flow

import React from 'react';
import _ from 'lodash';
import { connectRouter } from 'redux-router-kit';

import { GET_HELP_CTA, buildGetHelpPath } from '@zapier/product-get-help';

import HelpButton from 'app/common/components/HelpButton/HelpButton';
import z from 'app/common/z';
import { useZtFeatures } from '../ZtFeaturesContext';
import { useAccount } from 'app/common/components/contexts/AccountContext';

const HIDDEN_PAGE_TYPE = 'hidden';

type HelpButtonContainerProps = {
  router: () => void,
  routeTo: (route: string) => void,
};

const routeMatches: Object = {
  '/developer/start': {
    pageType: HIDDEN_PAGE_TYPE,
  },
  '/developer/documentation': {
    pageType: 'developer',
    onClick: buildGetHelpPath({ topic: 'developer' }),
  },
  '/developer/': {
    pageType: 'developer',
    onClick: ({ routeTo, shouldUseZtFeatures }) => {
      const maybeApp = _.get(z, ['app', 'developer', 'app']);
      const selectedApi = maybeApp ? maybeApp.selectedApi() : '';
      const url = selectedApi
        ? buildGetHelpPath({ topic: 'developer', app: selectedApi })
        : shouldUseZtFeatures
        ? 'https://developer.zapier.com/contact'
        : '/developer/documentation';
      routeTo(url);
    },
  },
  '/get-help': {
    pageType: HIDDEN_PAGE_TYPE,
  },
  '/editor/': {
    pageType: HIDDEN_PAGE_TYPE,
  },
  '/history': {
    // Replaced by the GetHelpCta component in @zapier/product-get-help
    pageType: HIDDEN_PAGE_TYPE,
  },
  '/': {
    pageType: 'other',
    onClick: '/help/',
  },
};

const HelpButtonContainer = (props: HelpButtonContainerProps) => {
  const { account } = useAccount();
  const isChatEligible = account?.data?.is_chat_eligible;
  const { shouldUseZtFeatures } = useZtFeatures();
  const findMatch = () => {
    const { router } = props;
    const { current } = router;
    const url = (current ? current.url : '/') || '/';
    const matchKey =
      _.find(Object.keys(routeMatches), key => url.includes(key)) ||
      routeMatches['/'];
    const result = routeMatches[matchKey];
    if (url.includes('/billing') && isChatEligible) {
      result.pageType = HIDDEN_PAGE_TYPE;
    }
    return result;
  };

  const onClick = () => {
    const { routeTo } = props;
    const match = findMatch();

    if (_.isString(match.onClick)) {
      routeTo(match.onClick);
    }
    if (_.isFunction(match.onClick)) {
      match.onClick({ ...props, shouldUseZtFeatures });
    }
  };

  const match = findMatch();
  const shouldHideButton = match.pageType === HIDDEN_PAGE_TYPE;

  return (
    <HelpButton
      children={GET_HELP_CTA.split(' ').map(_.capitalize).join(' ')}
      icon={'help'}
      onClick={onClick}
      shouldHideButton={shouldHideButton}
    />
  );
};

export default connectRouter(HelpButtonContainer);
